// extracted by mini-css-extract-plugin
export default {"wrapper":"FExHeader_wrapper__bJPK+","header":"FExHeader_header__WTEIN","instructions":"FExHeader_instructions__zQSoY"};